<div class="footer">
  &copy; IREV, {{ year }}. <span i18n="@@common.all_rights_reserved">All Rights Reserved</span>.
  <span i18n="@@common.client_version">Client Version</span>: {{ frontendVersion }}.
  <ng-container *ngIf="apiVersion"> <span i18n="@@common.api_version">API Version</span>: {{ apiVersion }} </ng-container>
</div>
